export const DAMAGE_TYPE_PHYSICAL = 1;
export const DAMAGE_TYPE_NON_PHYSICAL = 2;

export const DAMAGE_TYPE_OPTIONS = [
    { value: DAMAGE_TYPE_PHYSICAL, text: "Fisik" },
    { value: DAMAGE_TYPE_NON_PHYSICAL, text: "Non Fisik" }
];

export function damageTypeLabel(v) {
    const found = DAMAGE_TYPE_OPTIONS.find(o => o.value == v);
    return found ? found.text : "-";
}

// getType(option) returns the option's damage_type (1/2/null). Empty groups are omitted.
export function groupByDamageType(options, getType) {
    const groups = [
        { label: "Fisik", type: DAMAGE_TYPE_PHYSICAL, options: [] },
        { label: "Non Fisik", type: DAMAGE_TYPE_NON_PHYSICAL, options: [] },
        { label: "Belum ada tipe", type: null, options: [] }
    ];
    options.forEach(o => {
        const t = getType(o);
        const g = groups.find(g => g.type !== null && g.type == t) || groups[2];
        g.options.push(o);
    });
    return groups.filter(g => g.options.length > 0).map(({ label, options }) => ({ label, options }));
}
